<button mat-raised-button color="primary" (click)="fileTrigger.click()"><mat-icon>file_upload</mat-icon> Hochladen</button>
<input class="form-control invisible" type="file" (change)="onChange($event)" #fileTrigger>
